import {takeLatest} from "redux-saga";
import {fork, put, take} from "redux-saga/effects";
import {generateUUID} from "../lib/UUID";
import * as ViewActions from "../actions/ViewActions";
import {
  showModalWindow,
  removeModalWindow
  } from "../actions/WindowActions";


// Handle GUI for date picker.
function* showDatePicker(baseAction) {
  let windowId = generateUUID();
  yield put(showModalWindow(windowId, "DatePickerWindow", {field: baseAction.field, date: baseAction.date, options: baseAction.options}, "Pick a date"));
  yield take([ViewActions.CLOSE_DATE_PICKER]);
  yield put(removeModalWindow(windowId));
}
function* watchShowDatePicker() {
  yield takeLatest(ViewActions.SHOW_DATE_PICKER, showDatePicker);
}

export default function* viewSaga() {
  yield fork(watchShowDatePicker);
}
